import React, { useState, useCallback } from 'react';
import Toast from './Toast';
import './Toast.css';

let toastId = 0;
let addToastCallback = null;

export const toast = {
  success: (message, duration) => addToastCallback?.({ type: 'success', message, duration }),
  error: (message, duration) => addToastCallback?.({ type: 'error', message, duration }),
  warning: (message, duration) => addToastCallback?.({ type: 'warning', message, duration }),
  info: (message, duration) => addToastCallback?.({ type: 'info', message, duration }),
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type, message, duration = 5000 }) => {
    const id = toastId++;
    setToasts((prev) => [...prev, { id, type, message, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  // Set the global callback
  React.useEffect(() => {
    addToastCallback = addToast;
    return () => {
      addToastCallback = null;
    };
  }, [addToast]);

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          message={toast.message}
          duration={toast.duration}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
